import { render } from "./cwc_head.vue?vue&type=template&id=5869aa5a&scoped=true"
import script from "./cwc_head.vue?vue&type=script&lang=js"
export * from "./cwc_head.vue?vue&type=script&lang=js"

import "./cwc_head.vue?vue&type=style&index=0&id=5869aa5a&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5869aa5a"]])

export default __exports__